import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 75,
    stylesTextInput: {
      textAlign: "left",
      fontSize: 19  ,
      background: "none",
      height: 24,
      borderBottom: "3px dotted black",
      // fontWeight: 600
    },
    titleQuestion: [
      {
        num: "1",
        title: `
        Viết tiếp vào chỗ chấm cho thích hợp (theo mẫu)
				`,
        color: "black",
      },
    ],
    
    questionImage: [],
    isHiddenCheck: true,
    isEssay:true,
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page5/E1/1.jpg' style= "width:14cm; margin-left: 20px"/>
        <div style= "position: relative; left: 440px; top: -325px;"> <input id= "0"> </div>
        <div style= "position: relative; left: 105px; top: -220px;"> <input id= "0"> </div>
        <div style= "position: relative; left: 440px; top: -259px;"> <input id= "0"> </div>
        <div style= "position: relative; left: 105px; top: -150px;"> <input id= "0"> </div>
        <div style= "position: relative; left: 440px; top: -189px;"> <input id= "0"> </div>
        `,
        answer: [
          "Nhọn",
          "Bẹt",
          "Vuông",
          "Tù",
          "Nhọn",
        ],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay : true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/E2/key/E2answerKey.png",
    
    titleQuestion: [
      {
        num: "2",
        title: "Bạn Nam vẽ hai mũi tàu như hình sau, Em hãy ghi chữ A vào con tàu có mũi là một góc tù và B vào con tàu có mũi là một góc tù",
		    color: "black",
      },
    ],
   
    component: T6,
    totalInput: 5,
	isHiddenCheck:true,
	Recorder:true,
    titleImage: "",
	inputSize: 70,
    isAllowSubmit: false,
	questionImage: [],
	stylesTextInput: {
		textAlign: "center",
		fontSize: 23,
    maxLength: 3,
    background: "none",
    borderBottom: "3px dotted black",
    maxLength: 1
	},
    questions: [
      {
		title: `
		 <img src='/img/FriendsPlus/Page5/E2/1.jpg' style='height:5cm; margin-left: 110px; margin-top: 10px'/>
     <div style= "position: relative; left: 290px; top: 10px;"> <input id= "0"> </div>
     <div style= "position: relative; left: 740px; top: -28px;"> <input id= "1"> </div>
		`,
		answer:[ `A`, `B` ]
	  }
    ],
  },
};

export default json;
